import { format } from "date-fns";

export function getCurrentDate(separator = "") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${year}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${date}`;
}

export const dateFormat = (date, options = {}) => {
  if (!date) return date;

  const { pattern = "dd MMM HH:mm" } = options;
  return format(new Date(date), pattern);
};
